import { toast } from 'shared/components/ui/use-toast';
import { createLogger } from 'shared/logger';

const log = createLogger('ChatSend');

// Surface a failed message send to the user. The chat-input path already
// shows an error (ChatPanel.handleSendMessage); this covers the artifact
// pill / onSend paths that previously only console.error'd, leaving the
// advisor with a click that silently did nothing.
export function notifySendFailure(
  logContext: string,
  error: unknown,
  description = 'Il messaggio non è stato inviato. Riprova.',
): void {
  log.error(logContext, { error });
  toast({
    title: 'Errore di invio',
    description,
    variant: 'destructive',
  });
}
